import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { MarketplaceRequest } from '~client/model/admin/marketplace-request';
import { MarketplaceResponse } from '~client/model/admin/marketplace-response';
import { MarketplaceTranslationsRequest } from '~client/model/admin/marketplace-translations-request';
import { CreateOfferGroupRequest } from '~client/model/admin/create-offer-group-request';
import { OfferGroupResponse } from '~client/model/admin/offer-group-response';
import { OfferGroupTranslationsRequest } from '~client/model/admin/offer-group-translations-request';
import { ResponseEntity } from '~client/model/response-entity';

/* Admin APIs to create event. */
export class MarketplaceAdminController extends BaseController {
  public createMarketplace$(request: MarketplaceRequest): Observable<MarketplaceResponse> {
    return this.post$('/marketplace', request);
  }

  public addMarketplaceTranslations$(
    request: MarketplaceTranslationsRequest,
  ): Observable<ResponseEntity> {
    return this.put$('/marketplace/addTranslations', request);
  }

  public createOfferGroup$(request: CreateOfferGroupRequest): Observable<OfferGroupResponse> {
    return this.post$('/marketplace/offerGroup', request);
  }

  public addOfferGroupTranslations$(
    request: OfferGroupTranslationsRequest,
  ): Observable<ResponseEntity> {
    return this.put$('/marketplace/offerGroup/addTranslations', request);
  }

  public enableMarketplace$(marketplaceId: number): Observable<MarketplaceResponse> {
    return this.put$(`/marketplace/enable?marketplaceId=${marketplaceId}`);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/controller/marketplace-admin-controller.ts